module.exports = __webpack_public_path__ + "static/media/style.5e7eeb63.less";